import { GeoJsonObject } from "geojson";
import * as L from "leaflet";
import { Layer, LeafletMouseEvent } from "leaflet";

var geojson: any;

declare global {
    interface Window { getJson: any; }
}

document.addEventListener("DOMContentLoaded", function () {

  if (!document.querySelector("#map")) {
    return;
  }
var data = window.getJson() as GeoJsonObject;
  var map = new window.L.Map("map", {
    center: [63, 18],
    zoomSnap: 0.2,
    zoom: 5,
    zoomControl: false,
    attributionControl: false,
    scrollWheelZoom: false,
    doubleClickZoom: false,
    dragging: false,
    keyboard: false,
  });

  map.setZoom(4.8);
  map.on("mouseout", function () {
    map.closePopup();
  });

  geojson = window.L.geoJson(data, { style: style, onEachFeature: (feature : any, layer: Layer) => onEachFeature(feature, layer, map) }).addTo(map);
});

function getColor(d: number) {
  return d === 1
    ? "#E2EAF7"
    : d === 2
      ? "#7EA2DC"
      : d === 3
        ? "#3B4992"
        : d === 4
          ? "#232948"
          : "#FFF";
}

function getStatus(code: string) {
  var lvl1Headline = (document.querySelector("#status_regions_accordionlvl1") as HTMLElement)?.dataset.headline;
  var lvl2Headline = (document.querySelector("#status_regions_accordionlvl2") as HTMLElement)?.dataset.headline;
  var lvl3Headline = (document.querySelector("#status_regions_accordionlvl3") as HTMLElement)?.dataset.headline;
  var lvl4Headline = (document.querySelector("#status_regions_accordionlvl4") as HTMLElement)?.dataset.headline;
  var lvl1Regions = (document.querySelector("#status_regions_accordionlvl1") as HTMLElement)?.dataset.regions?.split(",");
  var lvl2Regions = (document.querySelector("#status_regions_accordionlvl2") as HTMLElement)?.dataset.regions?.split(",");
  var lvl3Regions = (document.querySelector("#status_regions_accordionlvl3") as HTMLElement)?.dataset.regions?.split(",");
  var lvl4Regions = (document.querySelector("#status_regions_accordionlvl4") as HTMLElement)?.dataset.regions?.split(",");
  if (lvl1Regions?.includes(code)) {
    return lvl1Headline;
  } else if (lvl2Regions?.includes(code)) {
    return lvl2Headline;
  } else if (lvl3Regions?.includes(code)) {
    return lvl3Headline;
  } else if (lvl4Regions?.includes(code)) {
    return lvl4Headline;
  } else {
    return "Inte ansluten";
  }
}

function style(feature: any) {
  var lvl1Regions = (
    document.querySelector("#status_regions_accordionlvl1") as HTMLElement
  )?.dataset?.regions?.split(",");
  var lvl2Regions = (
    document.querySelector("#status_regions_accordionlvl2") as HTMLElement
  )?.dataset?.regions?.split(",");
  var lvl3Regions = (
    document.querySelector("#status_regions_accordionlvl3") as HTMLElement
  )?.dataset?.regions?.split(",");
  var lvl4Regions = (
    document.querySelector("#status_regions_accordionlvl4") as HTMLElement
  )?.dataset?.regions?.split(",");
  var status = 0;
  if (lvl1Regions?.includes(feature.properties.kod)) {
    status = 1;
  } else if (lvl2Regions?.includes(feature.properties.kod)) {
    status = 2;
  } else if (lvl3Regions?.includes(feature.properties.kod)) {
    status = 3;
  } else if (lvl4Regions?.includes(feature.properties.kod)) {
    status = 4;
  }
  return {
    fillColor: getColor(status),
    weight: 1,
    opacity: 1,
    color: "#232948",
    fillOpacity: 1,
    backgroundColor: "white",
  };
}

function highlightFeature(e: LeafletMouseEvent, status : any, layer: Layer, map: L.Map) {
  var target = e.target;
  layer.openPopup();
    target?.setStyle({
      weight: 5,
      color: "#666",
      dashArray: "",
      fillOpacity: 0.7,
    });
    target.bringToFront();
}

function resetHighlight(e: LeafletMouseEvent) {
  geojson.resetStyle(e.target);
}

function onEachFeature(feature: any, layer: Layer, map: L.Map) {
  var status = layer.bindPopup(
    '<div class="map-popup"><strong>' +
      feature.properties.name +
      "</strong><p class='map-popup__text'>" +
      getStatus(feature.properties.kod) +
      "</p></div>",
    { autoPan: false },
  );
  layer.on({
    mouseover: (e) => highlightFeature(e, status, layer, map),
    mouseout: resetHighlight,
  });
}
